const apiClient = () => {
    // const client = process.env.IS_WEB ?
    //     require('./ApiClientWeb') :
    //     require('./ApiClientMobile');

    const client = require('./ApiClientWeb');
    return new client.default();
};

export { apiClient };


// WEBPACK FOOTER //
// ./~/pluton-core/lib/api/index.js